import React, {useContext} from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import { buyNowContext } from "../BuyNow";
import HeaderCompanyLogo from "../../../common/HeaderCompanyLogo";
import { useHideHeaderOnMobile, useViewport } from "../../utils/custom_hooks";

const ConfirmationHeader = ({ displayOrderDetailsDropdown, showOrderDetails, setShowOrderDetails }) => {
  const { width } = useViewport();
  const { portal } = useContext(buyNowContext);
  useHideHeaderOnMobile("confirmation-header", width, 700);

  const onClickShowOrderDetails = () => {
    const summaryDropMenu = document.querySelector('#summary');
    setShowOrderDetails(!showOrderDetails);
    showOrderDetails ? enableBodyScroll(summaryDropMenu): disableBodyScroll(summaryDropMenu);
  };

  return (
    <header id="confirmation-header" className='container-fluid fixed-top bg-white'>
      <nav id="order-nav" className='row d-flex align-items-center position-relative px-2 py-3'>
        <div className='col-3 ps-0 ps-lg-3'>
          <HeaderCompanyLogo portal={portal} />
        </div>

        {displayOrderDetailsDropdown &&
          <div className="col-6 dropdown d-lg-none d-flex justify-content-end pe-0" onClick={onClickShowOrderDetails}>
            <div
              role="button"
              className='fw-bolder plan-price-txt d-inline me-1 text-nowrap text-dark'
            >
              Your order details
            <i className={"ps-1 fa " +(showOrderDetails ? "fa-chevron-up" : "fa-chevron-down")} style={{ color: "var(--main-color)"}}/>
            </div>
          </div>
        }
      </nav>
      <div className='d-lg-none w-100 position-absolute divider'/>
    </header>
  )
};

export default ConfirmationHeader